import { Box, ButtonBase, Stack } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';

const cardBaseStyles = (theme: Theme) => ({
	display: 'flex',
	flexDirection: 'column' as const,
	alignItems: 'stretch',
	width: '100%',
	padding: 0,
	paddingBottom: 16,
	gap: 8,
	overflow: 'hidden',
	textAlign: 'left' as const,
	backgroundColor: theme.palette.neutral?.main ?? '#FFFFFF',
	border: `0.25px solid ${theme.palette.primary[200]}`,
	borderRadius: 16,
	boxShadow: '6.056px 9.083px 28.26px 0px rgba(14, 28, 91, 0.1)',
});

export const StyledOperatorCard = styled(ButtonBase)(({ theme }) => ({
	...cardBaseStyles(theme),
	cursor: 'pointer',
}));

export const StyledOperatorCardBox = styled(Box)(({ theme }) =>
	cardBaseStyles(theme)
);

export const StyledOperatorImageWrapper = styled(Box)({
	position: 'relative',
	width: '100%',
	height: 193,
	borderTopLeftRadius: 8,
	borderTopRightRadius: 8,
	background: 'linear-gradient(180deg, #E5EFF8 0%, #FFFFFF 100%)',
	overflow: 'hidden',
});

export const StyledOperatorImage = styled('img')({
	position: 'absolute',
	inset: 0,
	width: '100%',
	height: '100%',
	objectFit: 'cover',
	objectPosition: 'center top',
});

export const StyledOperatorImageGradientOverlay = styled(Box)({
	position: 'absolute',
	inset: 0,
	background: 'linear-gradient(180deg, rgba(255,255,255,0) 55%, #FFFFFF 100%)',
	pointerEvents: 'none',
});

export const StyledOperatorTitleRow = styled(Stack)({
	position: 'absolute',
	left: 0,
	right: 0,
	bottom: 8,
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: 10,
	padding: '0 12px',
});

export const StyledOperatorLogo = styled('img')({
	width: 24,
	height: 24,
	borderRadius: 24,
	objectFit: 'cover',
	flexShrink: 0,
});

export const StyledOperatorDescription = styled(Box)({
	padding: '0 12px',
	width: '100%',
	whiteSpace: 'pre-line',
	boxSizing: 'border-box',
	minWidth: 0,
});
